<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'DouyinConfig',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'douyinConfig:add',
        update: 'douyinConfig:update',
        delete: 'douyinConfig:delete',
        deleteBatch: 'douyinConfig:deleteBatch'
      },
      url: {
        get: '/douyinConfig/listByCondition',
        add: '/douyinConfig/add',
        update: '/douyinConfig/update',
        delete: '/douyinConfig/delete',
        delete_batch: '/douyinConfig/deleteBatch',
        status: '/douyinConfig/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      },
        // {
        //   field: 'agentId',
        //   label: '代理',
        //   selectUrl: '/agent/getAll',
        //   selectData: [],
        //   show: {
        //     type: 'select',
        //   },
        //   width: '',
        // },
        {
          field: 'douyinKey',  // 字段名
          label: 'key',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'douyinSecret',  // 字段名
          label: 'secret',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'status',  // 字段名
          label: '密钥状态',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          status: true
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'agentId',
            label: '代理',
            type: 'select',
            selectUrl: '/agent/getAll',
            selectData: [],
            placeholder: '请选择',
            rules: [{
              message: '请选择代理', trigger: 'blur', required: true
            }],
            add: true,
            update: true,
          }, {
            field: 'douyinKey',  // 字段名
            label: 'key',  // 字段显示名称
            type: 'input',
            placeholder: '请输入key',
            rules: [
              {required: true, message: 'key不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'douyinSecret',  // 字段名
            label: 'secret',  // 字段显示名称
            type: 'input',
            placeholder: '请输入secret',
            rules: [
              {required: true, message: 'secret不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'status',
            label: '密钥状态：',
            type: 'select',
            placeholder: '请选择抖音密钥开启状态',
            rules: [{required: true, message: '请选择抖音密钥开启状态', trigger: 'blur'}],
            selectData: [{
              id: 0,
              name: '关闭'
            }, {
              id: 1,
              name: '开启'
            },],
            add: true,
            update: true,
            filterable: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
